import {ScrollView, View} from 'react-native';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import getStyles from './ADAPT-MH.styles';

type Props = {
  title: string;
  subtitle: string;
};

const ClinicianPlaceholder: React.FC<Props> = ({title, subtitle}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            {title}
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            {subtitle}
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            Content to be added later.
          </Text>
          <Text style={styles.listItem}>
            This section is reserved for the ADAPT-MH clinical team to define in a later build.
          </Text>
        </View>
      </ScrollView>
    </PageContainer>
  );
};

export default ClinicianPlaceholder;
